import { FAQ } from '../types/tutorials.types';

/**
 * Frequently Asked Questions database
 */
export const FAQS: FAQ[] = [
  {
    id: 'faq-001',
    question: '¿Cómo inicio una sesión en MedioPunto?',
    answer: 'Para iniciar una sesión, ve a la pantalla principal y haz clic en "Iniciar Sesión". Luego, ingresa el monto inicial de caja y confirma. Una vez iniciada la sesión, podrás comenzar a tomar pedidos.',
    tags: ['sesiones'],
    subTags: ['iniciar-sesion'],
    isNew: false,
    isImportant: true,
    lastUpdated: '2025-11-01'
  },
  {
    id: 'faq-002',
    question: '¿Qué es el arqueo de caja y cuándo debo hacerlo?',
    answer: 'El arqueo de caja es el proceso de verificar que el dinero físico en caja coincida con las ventas registradas. Debes hacerlo al finalizar cada turno o sesión para asegurarte de que los números cuadren correctamente.',
    tags: ['sesiones'],
    subTags: ['arqueo-caja', 'cerrar-sesion'],
    isNew: false,
    isImportant: true,
    lastUpdated: '2025-11-01'
  },
  {
    id: 'faq-003',
    question: '¿Puedo tener más de un turno en una sesión?',
    answer: 'Sí, puedes crear múltiples turnos dentro de una misma sesión. Esto es útil para separar las ventas entre diferentes períodos del día (almuerzo/cena) o entre cambios de personal.',
    tags: ['turnos', 'sesiones'],
    subTags: ['crear-turno'],
    isNew: false,
    isImportant: false,
    lastUpdated: '2025-11-01'
  },
  {
    id: 'faq-004',
    question: '¿Cómo muevo un producto de una mesa a otra?',
    answer: 'Abre la mesa origen, selecciona los productos que quieres mover, haz clic en "Mover" y elige la mesa destino. Los productos se transferirán automáticamente sin necesidad de eliminarlos.',
    tags: ['pedidos'],
    subTags: ['mover-productos', 'editar-pedido'],
    isNew: false,
    isImportant: false,
    lastUpdated: '2025-10-28'
  },
  {
    id: 'faq-005',
    question: '¿Qué es el modo hoster?',
    answer: 'El modo hoster es una vista especial que te permite gestionar todas las mesas de tu restaurant de forma visual y en tiempo real. Puedes ver el estado de cada mesa, asignar nuevas mesas, y controlar el flujo de clientes de manera eficiente.',
    tags: ['pedidos', 'configuracion'],
    subTags: ['modo-hoster'],
    isNew: true,
    isImportant: true,
    lastUpdated: '2025-10-28'
  },
  {
    id: 'faq-006',
    question: '¿Cómo separo la cuenta entre diferentes clientes?',
    answer: 'Dentro de una mesa, selecciona "Separar Cuenta", elige los productos que corresponden a cada comensal y genera las cuentas individuales. Cada persona podrá pagar su parte de manera independiente.',
    tags: ['pedidos', 'pagos'],
    subTags: ['separar-cuenta'],
    isNew: false,
    isImportant: false,
    lastUpdated: '2025-10-28'
  },
  {
    id: 'faq-007',
    question: '¿Cómo funciona el sistema de membresías?',
    answer: 'El sistema de membresías te permite crear diferentes niveles de beneficios para tus clientes frecuentes. Puedes configurar descuentos automáticos, puntos de fidelidad, y promociones exclusivas para miembros.',
    tags: ['clientes'],
    subTags: ['membresias', 'fidelizacion'],
    isNew: true,
    isImportant: true,
    lastUpdated: '2025-11-02'
  },
  {
    id: 'faq-008',
    question: '¿Puedo juntar mesas para grupos grandes?',
    answer: 'Sí, puedes juntar múltiples mesas en una sola cuenta. Selecciona las mesas que quieres unir y confirma. Todos los pedidos se consolidarán en una sola cuenta que podrás gestionar como una mesa única.',
    tags: ['pedidos'],
    subTags: ['juntar-mesas'],
    isNew: false,
    isImportant: false,
    lastUpdated: '2025-10-28'
  },
  {
    id: 'faq-009',
    question: '¿Qué hago si cometí un error al cerrar la sesión?',
    answer: 'Si ya cerraste la sesión y detectaste un error, contacta a soporte inmediatamente. Los datos de sesiones cerradas quedan registrados y pueden ser revisados para hacer las correcciones necesarias.',
    tags: ['sesiones'],
    subTags: ['cerrar-sesion', 'arqueo-caja'],
    isNew: false,
    isImportant: true,
    lastUpdated: '2025-11-01'
  },
  {
    id: 'faq-010',
    question: '¿Cómo creo un nuevo menú?',
    answer: 'Ve a la sección de Menús, haz clic en "Crear Menú", ingresa el nombre y descripción del menú, luego añade las categorías que deseas incluir. Puedes configurar múltiples menús para diferentes horarios u ocasiones.',
    tags: ['menus'],
    subTags: ['crear-menu'],
    isNew: false,
    isImportant: false,
    lastUpdated: '2025-11-01'
  },
  {
    id: 'faq-011',
    question: '¿Cómo abro el local en MedioPunto?',
    answer: 'Para abrir el local: 1) Abre el tenedor naranja anclado en tu barra de tareas (centro de impresión - debe permanecer abierto para poder imprimir). 2) Ingresa a mediopunto.ai en tu navegador con tu correo y contraseña. 3) En el panel principal, haz clic en "Iniciar sesión" en la parte superior central. 4) Selecciona la caja que deseas abrir e introduce el monto inicial en efectivo. ¡Listo para atender!',
    tags: ['sesiones'],
    subTags: ['iniciar-sesion'],
    isNew: true,
    isImportant: true,
    lastUpdated: '2025-11-16'
  },
  {
    id: 'faq-012',
    question: '¿Cómo cierro el local en MedioPunto?',
    answer: 'Para cerrar el local: 1) Ve al panel principal haciendo clic en el logo de MedioPunto (esquina superior derecha). 2) Completa todas las "Acciones pendientes" que aparecen en la esquina superior derecha. 3) Una vez finalizado el arqueo, dirígete al centro superior y haz clic en el símbolo "v" con cronómetro. 4) Presiona "Finalizar sesión".',
    tags: ['sesiones'],
    subTags: ['cerrar-sesion', 'arqueo-caja'],
    isNew: true,
    isImportant: true,
    lastUpdated: '2025-11-16'
  },
  {
    id: 'faq-013',
    question: '¿Cómo realizo un cambio de turno?',
    answer: 'Para cambiar de turno: 1) Ve al panel principal haciendo clic en el logo de MedioPunto. 2) Completa todas las "Acciones pendientes" que aparecen en la esquina superior derecha. 3) Una vez finalizado el arqueo, haz clic en el símbolo "v" con cronómetro en la parte superior central. 4) Presiona "Nuevo turno" y acepta.',
    tags: ['turnos', 'sesiones'],
    subTags: ['cambiar-turno', 'cuadratura-turno'],
    isNew: true,
    isImportant: true,
    lastUpdated: '2025-11-16'
  },
  {
    id: 'faq-014',
    question: '¿Cómo realizo un arqueo de caja?',
    answer: 'Para realizar un arqueo: 1) Ve al panel principal haciendo clic en el logo de MedioPunto. 2) En "Acciones pendientes" (esquina superior derecha), completa cada acción. 3) La última actividad es el arqueo - haz clic en "Ir". 4) Presiona "Nuevo arqueo" y verifica que el detalle de tu máquina de pago física (Transbank, Mercado Pago, etc.) coincida con el total del sistema. Si coincide aparecerá "Cuadrado", si no "No cuadrado".',
    tags: ['sesiones'],
    subTags: ['arqueo-caja', 'cerrar-sesion'],
    isNew: true,
    isImportant: true,
    lastUpdated: '2025-11-16'
  },
  {
    id: 'faq-015',
    question: '¿Cómo genero el resumen de turno o sesión?',
    answer: 'Para generar el resumen: 1) Ve al menú lateral, selecciona "Finanzas" y luego "Ventas". 2) Baja en la pestaña "Ventas Generales" hasta encontrar el listado de detalles por sesión. 3) En cada sesión, encontrarás un ícono de documento en la esquina derecha. 4) Haz clic en el documento para ver el detalle completo y exportarlo en formato PDF.',
    tags: ['reportes', 'sesiones'],
    subTags: ['ventas-reportes'],
    isNew: true,
    isImportant: false,
    lastUpdated: '2025-11-16'
  },
  {
    id: 'faq-016',
    question: '¿Cómo creo un nuevo salón?',
    answer: 'Para crear un salón: 1) Ve al menú lateral, selecciona "Configuración" y luego "Salones". 2) Haz clic en "+ Crear salón" ubicado en la esquina superior derecha. 3) Completa la información solicitada y guarda.',
    tags: ['configuracion'],
    subTags: ['config-mesas'],
    isNew: true,
    isImportant: false,
    lastUpdated: '2025-11-16'
  },
  {
    id: 'faq-017',
    question: '¿Cómo creo y muevo mesas en un salón?',
    answer: 'Para crear una mesa: Ve a "Configuración" > "Salones" y haz clic en "+ Mesa" en la esquina superior derecha. Para mover una mesa: 1) Haz clic en la mesa que deseas mover. 2) Usa las flechas del teclado para posicionarla. 3) Una vez en el lugar deseado, haz clic en "Guardar" en el modal lateral donde también puedes modificar los detalles de la mesa.',
    tags: ['configuracion'],
    subTags: ['config-mesas'],
    isNew: true,
    isImportant: false,
    lastUpdated: '2025-11-16'
  },
  {
    id: 'faq-018',
    question: '¿Cómo creo un nuevo usuario?',
    answer: 'Para crear un usuario: 1) Ve al menú lateral, selecciona "Configuración" y luego "Usuarios". 2) Haz clic en el botón naranja "Crear usuario". 3) Rellena toda la información solicitada en el modal. 4) Finaliza haciendo clic en "Crear".',
    tags: ['usuarios'],
    subTags: ['crear-usuario'],
    isNew: true,
    isImportant: false,
    lastUpdated: '2025-11-16'
  },
  {
    id: 'faq-019',
    question: '¿Cómo edito o elimino un usuario?',
    answer: 'Para editar: Ve a "Configuración" > "Usuarios", haz clic en el lápiz al lado derecho del usuario, actualiza la información y presiona "Actualizar". Para eliminar: Haz clic en el basurero al lado del usuario y confirma en "Eliminar". IMPORTANTE: Cuando eliminas un usuario, este pierde total acceso a tu local. Esta acción es irreversible.',
    tags: ['usuarios'],
    subTags: ['permisos'],
    isNew: true,
    isImportant: true,
    lastUpdated: '2025-11-16'
  },
  {
    id: 'faq-020',
    question: '¿Cómo creo una invitación de usuario?',
    answer: 'Para crear una invitación: 1) Ve a "Configuración" > "Usuarios". 2) Haz clic en la sección "Invitaciones". 3) Presiona "+ Crear invitación" en el encabezado de la tabla. 4) Rellena la información necesaria y haz clic en "Crear". 5) Puedes compartir el link de invitación haciendo clic en el ícono de papeles en la columna de acciones.',
    tags: ['usuarios'],
    subTags: ['crear-usuario', 'permisos'],
    isNew: true,
    isImportant: false,
    lastUpdated: '2025-11-16'
  },
  {
    id: 'faq-021',
    question: '¿Cómo desactivo un menú?',
    answer: 'Para desactivar un menú: 1) Ve al menú lateral, selecciona "Menú" y luego "Menú". 2) Haz clic en el slider/botón verde que se encuentra al lado del título del menú que deseas desactivar. Esto desactivará el menú en la carta que visualizan tus clientes a través de Mi Punto Digital y también en la zona de toma de pedidos. Esta acción es reversible.',
    tags: ['menus'],
    subTags: ['editar-menu'],
    isNew: true,
    isImportant: false,
    lastUpdated: '2025-11-16'
  },
  {
    id: 'faq-022',
    question: '¿Cómo programo un menú por horarios?',
    answer: 'Para programar un menú por horas: 1) Ve a "Menú" > "Menú". 2) Haz clic en el slider/botón verde que tiene el texto "Configurar horario". 3) Selecciona el horario y los días en que prefieres que ese menú en particular esté activo. Esto te permite tener menús diferentes para almuerzo, cena u ocasiones especiales.',
    tags: ['menus'],
    subTags: ['editar-menu', 'crear-menu'],
    isNew: true,
    isImportant: false,
    lastUpdated: '2025-11-16'
  },
  {
    id: 'faq-023',
    question: '¿Cómo creo una categoría? ¿Qué son las categorías visibles y ocultas?',
    answer: 'Hay dos formas: Forma 1) Después de crear un menú, haz clic en este y selecciona "+ Crear categoría", luego rellena el formulario. Forma 2) Ve a "Menú" > "Categorías" y haz clic en "+ Crear categoría". Las categorías VISIBLES aparecen en tu carta para clientes y personal. Las categorías OCULTAS son útiles para combos (ej: "proteínas a elección" en un "Arma tu pizza") y optimizan el tiempo al mostrar todas las opciones sin cambiar de sección.',
    tags: ['menus'],
    subTags: ['categorias-menu', 'crear-menu'],
    isNew: true,
    isImportant: false,
    lastUpdated: '2025-11-16'
  },
  {
    id: 'faq-024',
    question: '¿Cómo creo un combo de productos?',
    answer: 'Para crear un combo (ej: "Promo Big Mac" con hamburguesa, papitas y empanadas): 1) Ve a "Menú" > "Ítems" y busca el ítem base. 2) Haz clic en el lápiz en la columna de acciones. 3) Busca "Agregados y Opciones", baja hasta "Configuración de Combos y Extras". 4) Haz clic en "+ Agregar grupo" y luego "+ Crear nuevo grupo". 5) Agrega todos los ítems que quieres enlazar con sus cantidades. 6) Presiona "Crear grupo de selección" y luego "Actualizar". Ahora los meseros podrán seleccionar los componentes del combo.',
    tags: ['menus', 'items'],
    subTags: ['crear-item', 'editar-item'],
    isNew: true,
    isImportant: false,
    lastUpdated: '2025-11-16'
  },
  {
    id: 'faq-025',
    question: '¿Cómo libero una mesa después de cobrar?',
    answer: 'Si tienes los permisos: 1) Ve a "Pedidos" > "Restaurante". 2) Haz clic en la mesa que deseas liberar. 3) Presiona "Generar Pre cuenta" y selecciona el tipo (una cuenta, en partes iguales, o personalizada). 4) Presiona el ícono de tarjeta, selecciona el método de pago y listo. Si no tienes permisos, solicita a tu jefatura el cierre de la mesa.',
    tags: ['pedidos', 'pagos'],
    subTags: ['crear-pedido'],
    isNew: true,
    isImportant: false,
    lastUpdated: '2025-11-16'
  },
  {
    id: 'faq-026',
    question: '¿Cómo imprimo la precuenta?',
    answer: 'Para imprimir la precuenta: 1) Ve a "Pedidos" > "Restaurante". 2) Haz clic en la mesa deseada. 3) Presiona "Generar Pre cuenta" y selecciona el tipo de precuenta (una cuenta, en partes iguales, o personalizada). 4) Presiona el ícono de impresora y listo.',
    tags: ['pedidos', 'impresion'],
    subTags: ['imprimir-recibos'],
    isNew: true,
    isImportant: false,
    lastUpdated: '2025-11-16'
  }
];
